module.exports = __webpack_public_path__ + "img/pdf.ef78dd67.svg";